<template lang="html">
  <div>
    <form @submit.prevent="register()" id="login-form">
      <div class="inner">
        <h1 class="text-center">Регистрация</h1>
        <div class="form-group" v-bind:class="{ error: errors.username[0] }">
          <label for="email">Имя пользователя</label>
          <input id="email" type="text" class="form-control" placeholder="Введите желаемое имя пользователя" v-model="data.username">
          <div class="error">{{ errors.username[0] }}</div>
        </div>
        <div class="form-group" v-bind:class="{ error: errors.password[0] }">
          <label for="password">Пароль</label>
          <input id="password" type="password" class="form-control" placeholder="Введите пароль" v-model="data.password">
          <div class="error">{{ errors.password[0] }}</div>
        </div>
        <div class="form-group" v-bind:class="{ error: errors.password2[0] }">
          <label for="password2">Пароль еще раз</label>
          <input id="password2" type="password" class="form-control" placeholder="Введите пароль повторно" v-model="data.password2">
          <div class="error">{{ errors.password2[0] }}</div>
        </div>
        <div class="text-center">
          <input type="submit" class="btn btn-primary btn-lg" value="Зарегистрироваться">
        </div>
        <div class="text-center">
          <router-link :to="{ name: 'login'}">Уже зарегистрированы? Войдите здесь</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { HTTP } from '@/http-common'
import helpers from '@/helpers'

export default {
  name: 'register',
  data () {
    return {
      data: {
        username: '',
        password: '',
        password2: ''
      },

      errors: {
        username: [],
        password: [],
        password2: [],
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    register () {
      let confirmPath = this.$router.resolve({
        name: 'confirm-email'
      }).href

      let data = JSON.stringify({
        dest_url: window.location.hostname + confirmPath,
        username: this.data.username,
        password: this.data.password,
        password2: this.data.password2
      })

      return HTTP.post('/users', data, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }).then((response) => {
        this.showMsg('Congrlatulations! The confirmation has been sent to your email')
        this.$router.push({ name: 'login' })
        return true
      }).catch(err => {
        this.fillErrors(this.errors, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (msg, type, title) {
      this.$parent.showPopupMsg(msg, type, title)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?2d01a9be